import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER, LOCALE_ID, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { CommonModule, DatePipe, CurrencyPipe } from '@angular/common';
import { appRoutes } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RoleGuard } from './guards/role-guard.service';
import { AuthenticationInterceptor } from './commonservice/authentication.interceptor';
import { HttpActivityService } from './shared/http-activity.service';
import { Observable } from 'rxjs';
import { usersReducer } from './store/users/users.reducer';
import { UsersEffects } from './store/users/users.effects';
import { AccountsService } from './shared/accounts.service';
import { KeycloakService } from 'keycloak-angular';
import { AuthenticationService } from './commonservice/authentication.service';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgxMaskModule } from 'ngx-mask';
import { SortableModule } from 'ngx-bootstrap/sortable';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { localStorageSyncReducer } from './store/users/users.meta-reducers';
import { ToastrModule } from 'ngx-toastr';
import { DefaultLayoutModule } from './layout/default-layout.module';
import { ErrorHandlerService } from './shared/logging.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { ReferenceDataCacheService } from './commonservice/reference-data-cache.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
  BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
  HttpClientModule,
  FormsModule,
  ReactiveFormsModule,
  BrowserAnimationsModule,
  CommonModule,
  DefaultLayoutModule,
  MatProgressSpinnerModule,
  MatDialogModule,
  // Bootstrap Modules
  BsDropdownModule.forRoot(),
  TabsModule.forRoot(),
  BsDatepickerModule.forRoot(),
  ModalModule.forRoot(),
  TypeaheadModule.forRoot(),
  TimepickerModule.forRoot(),
  PopoverModule.forRoot(),
  AccordionModule.forRoot(),
  NgxMaskModule.forRoot(),
  SortableModule.forRoot(),
  StoreModule.forRoot({ users: usersReducer }, { metaReducers: [localStorageSyncReducer] }),
  EffectsModule.forRoot([UsersEffects]),
  NgMultiSelectDropDownModule.forRoot(),
  NgCircleProgressModule.forRoot({
    // set defaults here
    "radius": 60,
    "space": -5,
    "outerStrokeWidth": 5,
    "outerStrokeColor": "#76C2AF",
    "innerStrokeColor": "#ffffff",
    "innerStrokeWidth": 5,
    "imageSrc": "",
    "imageHeight": 105,
    "imageWidth": 105,
    "showImage": true,
    "showBackground": false
  }),

  // Shared & Routing
  RouterModule.forRoot(appRoutes),

  // ✅ Keep only one ToastrModule.forRoot
  ToastrModule.forRoot({
    closeButton: true,
    positionClass: 'toast-bottom-center',
    preventDuplicates: true,
    enableHtml: true
  })
  ],
  providers: [
    AccountsService, 
    RoleGuard, 
    DatePipe, 
    CurrencyPipe, 
    KeycloakService, 
    ReferenceDataCacheService,
    {
      provide: APP_INITIALIZER,
      useFactory: keycloakLoaderFactory,
      deps: [AuthenticationService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: HttpActivityService,
      multi: true,
    },
    BsModalService,
    { provide: LOCALE_ID, useValue: 'en-AU' },
    { provide: ErrorHandler, useClass: ErrorHandlerService }
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
export function keycloakLoaderFactory(authenticationService: AuthenticationService): () => Promise<any> | Observable<any> {
  return () => authenticationService.init();
}
